import { render, staticRenderFns } from "./CustomerCreditStatistic.vue?vue&type=template&id=3d9c8938&scoped=true&"
import script from "./CustomerCreditStatistic.vue?vue&type=script&lang=js&"
export * from "./CustomerCreditStatistic.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCreditStatistic.vue?vue&type=style&index=0&id=3d9c8938&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9c8938",
  null
  
)

export default component.exports